import React from 'react';
import s from './BaseComp.scss';
// models
import { FeedInstance } from '../../models/feed';
import { linkHelper } from '../../utils/linkHelper';
import { LinkWrapper } from '.';

interface Props {
    article: FeedInstance
}

export const FocusImage = (props: Props) => {
    const { article } = props;
    return (
        <LinkWrapper className={s.focusImage} href={linkHelper(article.url)} title={article.title.replace('✎', '')}>
            <img className={s.image} src={article.images[0]} alt=""/>
            <div className={s.titleBox}>
                <p className={s.title}>{article.title.replace('✎', '')}</p>
            </div>
        </LinkWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/components/BaseComp/FocusImage.tsx